module.exports = __webpack_public_path__ + "static/media/close-blue-60v-alt.6eb4510e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/close-blue-60v-alt.svg
// module id = 543
// module chunks = 0